import { useEffect, useState } from 'react'
import BigNumber from 'bignumber.js'
import axios from "axios"



const useGetBNBPriceData = () => {
  const [data, setData] = useState<BigNumber>(new BigNumber(0))
  const API_URL = "https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd"


  useEffect(() => {
    const fetchData = async () => {
      const resp = await axios.get(API_URL);
      // axios.get(API_URL).then((re)=>{
      //   setCakePriceBusd(new BigNumber(re.data.data.price))
      // });
      console.log(resp.data.binancecoin.usd,"price");

      setData(new BigNumber(resp.data.binancecoin.usd))
    }

    fetchData()
  }, [])

  return data
}

export default useGetBNBPriceData